module.exports = __webpack_public_path__ + "static/media/rogue@2x.d1d1f4a8.jpg";